module.exports = __webpack_public_path__ + "img/suc4.2e664bf3.png";